import PropTypes from 'prop-types';
import React from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import CirclesBackground from '../../../images/circles-background.png';
import { ButtonLink, DivWithShadowAlternate } from '@styled';
import fonts from '@general/fonts';

const Container = styled(DivWithShadowAlternate)`
    padding: 64px 42px;
`;

const IconWrapper = styled.div`
    align-items: center;
    display: flex;
    height: 160px;
    justify-content: center;
    width: 160px;
`;

const Icon = styled.img`
    object-fit: cover;
`;

const Title = styled.h3`
    font-family: ${fonts.sans};
    font-size: 32px;
    font-style: normal;
    font-weight: 700;
    line-height: 42px;
    text-align: center;
`;

const Text = styled.p`
    font-family: ${fonts.sans};
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 26px;
    text-align: center;
`;

const MarketingCard = ({ icon, iconSize = 160, title, text, ctaText, ctaUrl }) => {
    const history = useHistory();

    return (
        <Container className="marketing-card" style={{ backgroundImage: `url(${CirclesBackground})` }}>
            {icon && (
                <div className="d-flex justify-content-center mb-1rem">
                    <IconWrapper>
                        <Icon src={icon} alt="" style={{ height: `${iconSize}px`, width: `${iconSize}px` }} />
                    </IconWrapper>
                </div>
            )}

            {title && <Title className="mb-1rem">{title}</Title>}
            {text && <Text>{text}</Text>}
            {ctaText && ctaUrl && (
                <div className="mt-1.25rem">
                    <ButtonLink
                        href={ctaUrl}
                        onClick={e => {
                            e.preventDefault();
                            history.push(ctaUrl);
                        }}
                    >
                        {ctaText}
                    </ButtonLink>
                </div>
            )}
        </Container>
    );
};

MarketingCard.propTypes = {
    icon: PropTypes.string,
    iconSize: PropTypes.number,
    title: PropTypes.string,
    text: PropTypes.string,
    ctaText: PropTypes.string,
    ctaUrl: PropTypes.string,
};

export default MarketingCard;
